/**
 * @generated SignedSource<<d221bf5ab1e0d25aba4ee33bbfd1e15d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ControlledUserSelectPaginationFragment_users$data = {
  readonly gwtUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly company: {
          readonly name: string;
        } | null | undefined;
        readonly firstName: string;
        readonly lastName: string;
        readonly rowId: UUID;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "ControlledUserSelectPaginationFragment_users";
};
export type ControlledUserSelectPaginationFragment_users$key = {
  readonly " $data"?: ControlledUserSelectPaginationFragment_users$data;
  readonly " $fragmentSpreads": FragmentRefs<"ControlledUserSelectPaginationFragment_users">;
};

import ControlledUserSelectPaginationQuery_Refetchable_graphql from './ControlledUserSelectPaginationQuery_Refetchable.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "gwtUsers"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "usersOrderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ControlledUserSelectPaginationQuery_Refetchable_graphql
    }
  },
  "name": "ControlledUserSelectPaginationFragment_users",
  "selections": [
    {
      "alias": "gwtUsers",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "userFilter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "usersOrderBy"
        }
      ],
      "concreteType": "GwtUsersConnection",
      "kind": "LinkedField",
      "name": "__ControlledUserSelect_gwtUsers_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GwtUsersEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GwtUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Company",
                  "kind": "LinkedField",
                  "name": "company",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "0cb794a009ea2475a4a0062f7b3b4a80";

export default node;
